import { render, staticRenderFns } from "./InsVoto.vue?vue&type=template&id=22ae8868&scoped=true&"
import script from "./InsVoto.vue?vue&type=script&lang=js&"
export * from "./InsVoto.vue?vue&type=script&lang=js&"
import style0 from "./InsVoto.vue?vue&type=style&index=0&id=22ae8868&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ae8868",
  null
  
)

export default component.exports